import { cn } from '@/lib/cn';

/** Shimmer placeholder. Respects reduced motion. */
export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      aria-hidden
      className={cn(
        'rounded-sm bg-sunken bg-[linear-gradient(100deg,transparent_30%,color-mix(in_oklab,var(--gh-surface)_70%,transparent)_50%,transparent_70%)] bg-[length:200%_100%] animate-shimmer motion-reduce:animate-none',
        className,
      )}
    />
  );
}

export function SkeletonText({ lines = 3, className }: { lines?: number; className?: string }) {
  return (
    <div className={cn('grid gap-2', className)} aria-hidden>
      {Array.from({ length: lines }, (_, i) => (
        <Skeleton key={i} className={cn('h-3.5', i === lines - 1 ? 'w-3/5' : 'w-full')} />
      ))}
    </div>
  );
}
